import React from 'react';
import { Box, Container, Typography, Link, Stack } from '@mui/material';
import { LogTabEventToGA } from '../googleAnalytics/GoogleAnalytics';
import {
  privacyPolicyLinkClickedText,
  termsOfServiceLinkClickedText,
} from '../googleAnalytics/GoogleAnalyticsConstants';

const Footer: React.FC = () => {
  return (
    <Box>
      {/* Footer */}
      <Box sx={{ bgcolor: '#1E1F22', color: '#ccc', py: 6 }}>
        <Container maxWidth="lg" sx={{ display: 'flex', justifyContent: 'space-between' }}>
          <Typography variant="body2">© 2025 Wipro</Typography>
          <Stack direction="row" spacing={2}>
            <Typography variant="body2">
              <Link
                href="./termsAndPolicies/terms_and_conditions.html"
                underline="hover"
                target="_blank"
                color="inherit"
                onClick={() => LogTabEventToGA(termsOfServiceLinkClickedText)}
              >
                Terms of Service
              </Link>
            </Typography>
            <Typography variant="body2">
              <Link
                href="./termsAndPolicies/privacy_policy.html"
                underline="hover"
                target="_blank"
                color="inherit"
                onClick={() => LogTabEventToGA(privacyPolicyLinkClickedText)}
              >
                Privacy Policy
              </Link>
            </Typography>
          </Stack>
        </Container>
      </Box>
    </Box>
  );
};

export default Footer;
